module.exports = __webpack_public_path__ + "img/arrow-right--orange.1d70ed11.svg";